export default __webpack_public_path__ + "static/media/953.d19bdb26.jpg";